module.exports = __webpack_public_path__ + "05_mustache_black.9b8969b7.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/male/layer3/05_mustache_black.png
// module id = Yi0D
// module chunks = 0